import { Fancybox } from "@fancyapps/ui";

// Fancybox.bind("[data-fancybox]", {

// });

Fancybox.bind("[data-fancybox]", {
  caption: function (fancybox, slide) {
    const custom_caption = slide.triggerEl?.closest('.fancybox-closest').querySelector(".fancybox-title");
    return custom_caption ? custom_caption.innerHTML : slide.caption || "";
  },
});
